import React from "react";
import { Form, Button } from "antd";
import { permissionUseMutation } from "../../hooks";
import { Localize, EntityRemoveButton } from "components/service";
import { localizeByKey } from "components/service/localize";
import Icons from "components/icons";
import Variable from "components/variable";
import { TPermission } from "../../helpers/permission-types-helper";

interface IPermissionEditFormProps {
    permission: TPermission | undefined;
}

const PermissionEditForm: React.FC<IPermissionEditFormProps> = ({ permission }) => {
    const [form] = Form.useForm();

    const { _setPermissionCreateUpdate, loadingMutationPermissionCreateUpdate } =
        permissionUseMutation.createUpdate(permission?.id);

    const { _setMutationPermissionDelete, loadingMutationPermissionDelete } =
        permissionUseMutation.delete(permission?.id);

    const entryPointMap: Record<string, string> = {
        permission_entry_point_library: "library",
        permission_entry_point_app: "app",
    };

    return (
        <Form
            key="edit-permission-form"
            layout="vertical"
            form={form}
            className="model-form edit-permission-form"

            onFinish={(values) => {
                const entry_point = entryPointMap[values.entry_point] || values.entry_point;
                _setPermissionCreateUpdate({
                    variables: {
                        input: {
                            id: permission?.id ? +permission.id : undefined,
                            ...values,
                            entry_point,
                        },
                    },
                });
            }}
        >
            <div className="row-grid grid-gap-10 grid-tablet" style={{ gridTemplateColumns: "1fr 1fr" }}>
                <Variable.Forms.Fields.VariablesSelect
                    form={form}
                    name="slug"
                    groupName="permission"
                    filterSlug="permission_"
                    excludeSlugs={["permission_group_", "permission_action_", "permission_entry_point_"]}
                    initialValue={permission?.slug || undefined}
                    label={localizeByKey("FORMS.Input_Label_Slug")}
                />
                <Variable.Forms.Fields.VariablesSelect
                        form={form}
                        name="group_name"
                        groupName="permission"
                        filterSlug="permission_group_"
                        initialValue={permission?.group_name || undefined}
                        label={localizeByKey("FORMS.Input_Label_GroupName")}
                    />

            </div>

            <div className="row-grid grid-gap-10 grid-tablet" style={{ gridTemplateColumns: "1fr 1fr" }}>
                <Variable.Forms.Fields.VariablesSelect
                    form={form}
                    name="action"
                    groupName="permission"
                    filterSlug="permission_action_"
                    initialValue={permission?.action}
                    label={localizeByKey("FORMS.Input_Label_Action")}
                />

                <Variable.Forms.Fields.VariablesSelect
                    form={form}
                    name="entry_point"
                    groupName="permission"
                    filterSlug="permission_entry_point_"
                    initialValue={permission?.entry_point}
                    label={localizeByKey("FORMS.Input_Label_EntryPoint")}
                />
            </div>

            <div className="form-btn-holder">
                {permission?.id && (
                    <EntityRemoveButton
                        modalButton={
                            <Button icon={<Icons.Delete />}>
                                <span className="ellipsis">
                                    <Localize>PERMISSION.Button_Text_Delete</Localize>
                                </span>
                            </Button>
                        }
                        nameEntity={localizeByKey("ENTITY.Modal_Title_Permission")}
                        dataNameEntity={`${permission?.slug || `${permission?.group_name}.${permission?.action}`}`}
                        loading={loadingMutationPermissionDelete}
                        deleteMutation={async (options) => {
                            await _setMutationPermissionDelete(options);
                        }}
                        variables={{
                            id: permission?.id,
                        }}
                    />
                )}
                <Button
                    className="btn-right"
                    type="primary"
                    htmlType="submit"
                    icon={permission?.id ? <Icons.Edit /> : <Icons.Plus />}
                    loading={loadingMutationPermissionCreateUpdate}
                >
                    <span className="ellipsis">
                        {permission?.id ? (
                            <Localize>GLOBAL.Button_Text_SaveChanges</Localize>
                        ) : (
                            <Localize>GLOBAL.Button_Text_CreateNew</Localize>
                        )}
                    </span>
                </Button>
            </div>
        </Form>
    );
};

export default PermissionEditForm;